export const PRODUCT_SUBSCRIPTION_ROUTE = 'product.page.subscription';
export const FLIP_DOOR_DIRECTION_SERVICE_TYPE_ID = 4;
export const ENVIRONMENTAL_RETURN_SERVICE_TYPE_ID = 10;
export const ENVIRONMENTAL_RETURN_SERVICE_GERMANY_TYPE_ID = 12;
export const DOORSTEP_DELIVERY_SERVICE_TYPE_ID = 19;
export const TELEVISIONS_PRODUCT_TYPE_ID = 2627;
export const UNDER_COUNTER_DISHWASHER_SUB_PRODUCT_TYPE_ID = 3639;
export const PLACE_AND_CONNECT_FREE_STANDING_DISH_WASHERS = 10256;
export const PLACE_AND_CONNECT_WASHING_MACHINES_AND_DRYERS_COMBOS = 10238;
export const PLACE_AND_CONNECT_AMERICAN_FRIDGES = 10259;
export const PLACE_AND_CONNECT_FRIDGES_AND_FREEZERS = 10260;
export const PLACE_AND_CONNECT_SMALL_FRIDGES_AND_FREEZERS = 10261;
export const PLACE_AND_CONNECT_FRIDGES_AND_FREEZERS_COMBOS = 10262;
export const PLACE_AND_CONNECT_SMALL_FRIDGES_AND_FREEZERS_COMBOS = 10263;
export const PLACE_AND_CONNECT_BUILTIN_DISH_WASHERS_AND_FRIDGES = 10264;
export const PLACE_AND_CONNECT_SMALL_FRIDGES = 10580;
export const PLACE_AND_CONNECT_DRYERS = 10860;
export const PLACE_AND_CONNECT_WASHER_DRYER_COMBINATIONS = 10877;
export const PLACE_AND_CONNECT_WASHING_MACHINES = 10857;
export const DOORSTEP_DELIVERY_AMERICAN_FRIDGES = 10378;
export const DOORSTEP_DELIVERY_WHITE_GOODS = 10863;
export const DOORSTEP_DELIVERY_LARGE_TVS = 10917;
export const DOORSTEP_DELIVERY_FRIDGES_AND_FREEZERS = 11057;
export const DOORSTEP_DELIVERY = 110;
export const PLACE_AND_CONNECT_PRODUCT_AS_A_SERVICE = 10938;
export const PLACE_AND_CONNECT_PRODUCT_AS_A_SERVICE_PRODUCT_ID = 917105;
export const INSTALLATION_SERVICES_PORTAL_ID = 'installation-services-portal';
export const PLACE_AND_CONNECT_SERVICES = [
    PLACE_AND_CONNECT_FREE_STANDING_DISH_WASHERS,
    PLACE_AND_CONNECT_WASHING_MACHINES_AND_DRYERS_COMBOS,
    PLACE_AND_CONNECT_AMERICAN_FRIDGES,
    PLACE_AND_CONNECT_FRIDGES_AND_FREEZERS,
    PLACE_AND_CONNECT_SMALL_FRIDGES_AND_FREEZERS,
    PLACE_AND_CONNECT_FRIDGES_AND_FREEZERS_COMBOS,
    PLACE_AND_CONNECT_SMALL_FRIDGES_AND_FREEZERS_COMBOS,
    PLACE_AND_CONNECT_BUILTIN_DISH_WASHERS_AND_FRIDGES,
    PLACE_AND_CONNECT_PRODUCT_AS_A_SERVICE,
    PLACE_AND_CONNECT_SMALL_FRIDGES,
    PLACE_AND_CONNECT_DRYERS,
    PLACE_AND_CONNECT_WASHER_DRYER_COMBINATIONS,
    PLACE_AND_CONNECT_WASHING_MACHINES,
];
export const DOORSTEP_DELIVERY_SERVICES = [
    DOORSTEP_DELIVERY_AMERICAN_FRIDGES,
    DOORSTEP_DELIVERY_WHITE_GOODS,
    DOORSTEP_DELIVERY_LARGE_TVS,
    DOORSTEP_DELIVERY_FRIDGES_AND_FREEZERS,
    DOORSTEP_DELIVERY,
];
//# sourceMappingURL=constants.js.map